import * as Sentry from '@sentry/react'

import { getGlitchTipBrowserConfig } from './monitoring/glitchtip'

const glitchTipConfig = getGlitchTipBrowserConfig()

if (glitchTipConfig.enabled) {
  Sentry.init({
    dsn: glitchTipConfig.dsn,
    environment: glitchTipConfig.environment,
    release: glitchTipConfig.release,
    tracesSampleRate: glitchTipConfig.tracesSampleRate,
  })

  if (glitchTipConfig.site) {
    Sentry.setTag('site', glitchTipConfig.site)
  }
}
